import { Sneladvies } from '../translations-types';

const translations: Sneladvies = {
  title: 'Especially for you',
  newBlock: 'New block',
  create: 'Add block',
  edit: 'Edit',
  text: 'Text',
  textPlaceholder: 'Type the text… (hyperlinks allowed)',
  saved: 'Saved',
  deleted: 'Deleted',
  deleteConfirm: 'Are you sure? The block will be deleted.',
  noBlocks: 'No blocks yet',
  panelTitle: 'Especially for you',
  panelHint: 'For the customer portal.',
  open: 'Select',
  selectBlocks: 'Select',
  publish: 'Send',
  published: 'Sent and customer notified',
  noneSelected: 'No blocks selected',
  portalEmpty: 'Nothing has been prepared especially for you yet.',
  dutch: 'Dutch',
  english: 'English',
  translateAuto: 'Auto-translate (NL → EN)',
  enAutoHint: 'Leave empty = auto-translated on save. Manually edited English text is kept.',
  translated: 'English version generated — review and save',
  noteLabel: 'Personal note',
  noteHint: 'Optional. It is kept and shown at the top of the portal and in the email to the customer.',
  notePlaceholder: 'Write a personal note for the customer…',
  previousNotes: 'Previous notes',
  noteFrom: 'from',
};

export default translations;
